import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

export default function Platform({ platformData, className }) {
    const { platform } = platformData,
        platformNameText = platform.replace('_', ' '),
        wrapperClassNames = `platform ${className} ${platform.replace('_', '-')}`,
        iconClassNames = `platform-icon ${platform} hint--top`;

    return (
        <li className={wrapperClassNames}>
            <i className={iconClassNames} aria-hidden="true" data-hint={platformNameText}/>
            <span className="text">{platformNameText}</span>
        </li>
    );
}

Platform.propTypes = {
    platformData: PropTypes.shape({
        platform: PropTypes.string
    }),
    className: PropTypes.string
};

Platform.defaultProps = {
    platformData: {
        platform: ''
    },
    className: ''
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/shared/Platform/index.js